import {
  Button,
  Col,
  Modal,
  Row,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { NFCeConsultaDto } from "../NFCe.Consulta.Dto";

interface Props {
  show: boolean;
  nfce: NFCeConsultaDto | undefined;
  onReturn: () => void;
  onDelete: (value: NFCeConsultaDto) => void;
  onPrint: (value: NFCeConsultaDto) => void;
  onDownloadXml: (value: NFCeConsultaDto) => void;
  onFetchStatus: (value: NFCeConsultaDto) => void;
  onDownloadDanfe: (value: NFCeConsultaDto) => void;
  onShareDanfe: (value: NFCeConsultaDto) => void;
}

const NFCeModalPropriedadesView = (props: Props) => {
  const finalizada = props.nfce?.codigoStatusResposta === 100;

  const onReturnHandler = () => {
    if (props.nfce) {
      props.onReturn();
    }
  };

  const onDeleteHandler = () => {
    if (props.nfce) {
      props.onReturn();
      props.onDelete(props.nfce);
    }
  };

  const onPrintHandler = () => {
    if (props.nfce) {
      props.onPrint(props.nfce);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.nfce) {
      props.onDownloadXml(props.nfce);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.nfce) {
      props.onFetchStatus(props.nfce);
    }
  };

  const onDownloadDanfe = () => {
    if (props.nfce) {
      props.onDownloadDanfe(props.nfce);
    }
  };

  const onShareDanfe = () => {
    if (props.nfce) {
      props.onShareDanfe(props.nfce);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFCe: {props.nfce?.numeroNF}</Col>
            <Col xs={6}>Serie: {props.nfce?.serie}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Envio: {props.nfce?.codigoStatusEnvio}-
              {props.nfce?.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.nfce?.codigoStatusResposta}-
              {props.nfce?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {finalizada && (
            <>
              <DropdownButton
                variant="outline-primary"
                title="Imprimir"
                id="dropdown-imprimir"
                className="messagebox-btn-cancel"
              >
                <Dropdown.Item onClick={onPrintHandler}>
                  Imprimir agora
                </Dropdown.Item>

                <Dropdown.Item onClick={onShareDanfe}>
                  Compartilhar
                </Dropdown.Item>
                <Dropdown.Item onClick={onDownloadDanfe}>Baixar</Dropdown.Item>
              </DropdownButton>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onDownloadXmlHandler}
              >
                Baixar XML
              </Button>
            </>
          )}
          {!finalizada && (
            <>
              <Button
                variant="outline-danger"
                className="messagebox-btn-cancel"
                onClick={onDeleteHandler}
              >
                Excluir
              </Button>

              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onFetchStatusHandler}
              >
                Consultar Situação
              </Button>
            </>
          )}

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onReturnHandler}
          >
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NFCeModalPropriedadesView;
